import type { ApolloError } from 'apollo-client';

import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient';

import { SpaceDetailQuery } from './SpaceDetailQuery.graphql';
import type { SpaceDetailQuery as SpaceDetailQueryType } from './__types__/SpaceDetailQuery';

export const fetchSpaceDetail = (
	spaceKey: string | null | undefined = '',
): Promise<{
	data: SpaceDetailQueryType | null;
	loading?: boolean;
	error?: ApolloError | null;
}> => {
	if (spaceKey) {
		// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
		return getApolloClient().query({
			query: SpaceDetailQuery,
			variables: {
				spaceKey,
			},
		});
	}

	return Promise.resolve({ data: null, loading: false, error: null });
};
